import React, { useEffect, useState } from 'react'
import Slider from 'react-slick';
import Style from './FoodGrouping.module.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {getRestaurantCategory } from '../../Api/ClientServices';
import PointSpreadLoading from 'react-loadingg/lib/PointSpreadLoading';
import './food.css'
import { errorToast } from '../../Toast/Toast';

const FoodGrouping = (props) => {
  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none", background: "red" }}
        onClick={onClick}
      />
    );
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none", background: "green" }}
        onClick={onClick}
      />
    );
  }
  const settings = {
    infinite:true,
    speed: 500,
    slidesToShow: 11,
    slidesToScroll: 5,
    rtl: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive:[
      {
        breakpoint: 965,
        settings: {
          slidesToShow:10,
          slidesToScroll: 5,
          rtl: true,
        }
      },{
        breakpoint: 870,
        settings: {
          slidesToShow:9,
          slidesToScroll: 5,
          rtl: true,
        }
      },
      {
        breakpoint: 780,
        settings: {
          slidesToShow:8,
          slidesToScroll: 5,
          rtl: true,
        }
      },
      {
        breakpoint: 685,
        settings: {
          slidesToShow:7,
          slidesToScroll: 5,
          rtl: true,
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow:6,
          slidesToScroll: 5,
          rtl: true,
        }
      },
      {
        breakpoint: 511,
        settings: {
          slidesToShow:5,
          slidesToScroll: 5,
          rtl: true,
        }
      },
      {
        breakpoint: 435,
        settings: {
          slidesToShow:4,
          slidesToScroll: 4,
          rtl: true,
        }
      }
    ]
  };

  const [Data , setData]=useState()
  useEffect(()=>{
    getRestCategory()
  },[])

  const getRestCategory=async()=>{
    getRestaurantCategory((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setData(res.categories)
        }
      }else{
        console.error(res)
      }
    })
  }

  let loading=null
  if(Data===undefined){
    loading=<div className={Style.loading}><PointSpreadLoading color={'#ab0c59'} size={"small"} /></div>
    
  }
  else{
    loading=<Slider {...settings} className={Style.SliderTest}>
    {
      Data.map((item) =>
      {
        return(
          <div className={Style.GroupHolder} key={item.id} onClick={()=>props.filterProduct(item.category_english)}>
            {/* <img src={`http://cdn.barest.ir/category/${item.id}.jpg`} alt="" /> */}
            <div className={Style.FoodsTitleHolder}>
              <h3>{item.category_persian}</h3>
            </div>
          </div>
        )
      })
    }
    </Slider>
  }
  return (
    <div className={Style.SliderHolder}>
      {
        loading
      }
    </div> 
  )
}
export default FoodGrouping
